// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"1c06923a","517":"aafd747f"}[chunkId] + ".chunk.js";
};